import { tagsCreateMutation, tagsListQueryKey } from '@crm/api'
import { FormColorPicker } from '@shared/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { Form, Input, Modal } from 'antd'

import type { ModalProps } from 'antd'

const formName = 'add-tag'

type Props = {
  onClose: () => void
} & ModalProps

export const TagsForm = ({ onClose, ...props }: Props) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const [form] = Form.useForm()

  const { mutate } = useMutation({
    ...tagsCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: () => {
      onClose()
      form.resetFields()
      invalidateQueries([tagsListQueryKey()])
    }
  })

  const onSubmit = async () => {
    const values = await form.validateFields()
    mutate({
      body: {
        name: values.name,
        color: values.color?.toHexString?.() || values.color
      }
    })
  }

  return (
    <Modal
      mask={false}
      onCancel={onClose}
      title={t('tags.add')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
      {...props}
    >
      <Form form={form} name={formName} onFinish={onSubmit} layout="vertical">
        <Form.Item name="name" label={t('import.name')}>
          <Input />
        </Form.Item>

        <FormColorPicker
          initialValue="#1677ff"
          itemProps={{
            label: t('contacts.color')
          }}
          showText
        />
      </Form>
    </Modal>
  )
}
